import React from 'react';
import { Button } from './ui/button';
import { CheckCircle, MessageCircle, TrendingDown, Shield, Award } from 'lucide-react';

const Hero = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5512997176654?text=Olá! Gostaria de uma consultoria para montagem de PC. Podem me ajudar?', '_blank');
  };

  return (
    <section id="home" className="relative pt-20 pb-16 overflow-hidden bg-white">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-blue-50" />
      
      <div className="container mx-auto px-4 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 text-gray-900">
            <div className="space-y-6">
              <img 
                src="https://tecnotesjc.com.br/wp-content/uploads/2022/04/logotipo-tecnote-branco-300x53.png" 
                alt="Tecnote Logo" 
                className="h-12 w-auto mb-6"
              />
              
              <p className="text-xl text-gray-600 leading-relaxed">
                Somos uma empresa de tecnologia há mais de 8 anos no mercado, 
                trabalhando com Soluções em Computadores, Notebooks e Celulares.
              </p>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
                Consultoria
                <span className="block text-blue-600">Especializada</span>
                em Montagem de PC
              </h1>
              
              <p className="text-xl text-gray-600 leading-relaxed">
                Tenha um especialista ao seu lado na escolha das peças. 
                <strong className="text-gray-900"> Economize dinheiro</strong> e 
                <strong className="text-gray-900"> evite dores de cabeça</strong> 
                com nossa experiência de mercado.
              </p>
            </div>

            {/* Key Benefits */}
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <TrendingDown className="w-5 h-5 text-blue-600" />
                </div>
                <span className="text-gray-700 font-medium">Economia garantida</span>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <Shield className="w-5 h-5 text-blue-600" />
                </div>
                <span className="text-gray-700 font-medium">Compatibilidade 100%</span>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <CheckCircle className="w-5 h-5 text-blue-600" />
                </div>
                <span className="text-gray-700 font-medium">Montagem profissional</span>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <Award className="w-5 h-5 text-blue-600" />
                </div>
                <span className="text-gray-700 font-medium">Suporte especializado</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="bg-green-600 hover:bg-green-700 text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                onClick={handleWhatsAppClick}
              >
                <MessageCircle className="w-5 h-5 mr-3" />
                Saiba Mais
              </Button>
              
              <Button 
                variant="outline" 
                size="lg" 
                className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-6 text-lg font-semibold transition-all duration-300"
                onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Ver Planos
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center space-x-6 pt-4">
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-600">500+</div>
                <div className="text-sm text-gray-600">PCs montados</div>
              </div>
              <div className="w-px h-12 bg-gray-300" />
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-600">98%</div>
                <div className="text-sm text-gray-600">Satisfação</div>
              </div>
              <div className="w-px h-12 bg-gray-300" />
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-600">8+</div>
                <div className="text-sm text-gray-600">Anos mercado</div>
              </div>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative">
            <div className="relative z-10">
              <img 
                src="https://tecnotesjc.com.br/wp-content/uploads/2024/05/nova-foto-quem-somos.jpg" 
                alt="Tecnote - Profissionais em Ação" 
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;